import {useCallback, useEffect, useState} from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  ListItemButton,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import StarIcon from '@mui/icons-material/Star';
import relativeTime from 'dayjs/plugin/relativeTime';
import {ITaskItem} from '../../dto/Task.dto';
import rightArrow from '../../asset/icons/icon_rightarrow.svg';
import {IStyleProps} from '../../pages/staff-landing-page/StaffLandingPage';
import {dayJsNullHandler} from '../utlis/date-time/DayjsHandler';

dayjs.extend(relativeTime);

const convertToMilliseconds = (time: number, unit: string) => {
  if (unit === 'hr') {
    return time * 60 * 60 * 1000;
  } else {
    return time * 24 * 60 * 60 * 1000;
  }
};
const TaskListItemCard = ({
  task,
  handleNavigate,
  style,
}: {
  task: ITaskItem;
  handleNavigate: (task: ITaskItem) => void;
  tabValue: string;
  style: IStyleProps;
}) => {
  const [isExpired, setIsExpired] = useState(false);
  const handleClick = useCallback(() => {
    handleNavigate(task);
  }, [handleNavigate, task]);
  useEffect(() => {
    const createdAtDate = new Date(task.created_at);
    const convertedTime: number = convertToMilliseconds(
      task.completion_time,
      task.time_unit,
    );
    const timeoutId = setTimeout(
      setIsExpired,
      convertedTime + createdAtDate.getTime() - Date.now(),
      true,
    );
    return () => {
      clearTimeout(timeoutId);
    };
  }, [task.completion_time, task.created_at, task.time_unit]);
  return (
    <Card
      className={`shadow-gray border-width-3 radius-right-10 mb-3 px-7 py-4 cursor-pointer ${style.taskItemBackground} ${style.taskBorder}`}
      component={ListItemButton}
      id={`${task.requestable_type}-${task.requestable_id}`}
      onClick={handleClick}>
      <CardContent className='p-0 w-full'>
        <Grid container className='flex items-center justify-between mb-3'>
          <Typography
            id={`submitted-date-${task.id}`}
            gutterBottom
            variant='caption'
            title={dayjs(task.created_at).fromNow()}
            className='text-gray-variant6 text-14'>
            {dayJsNullHandler({
              t:
                task.requestable_type === 'user'
                  ? task.created_at
                  : task.requestable?.created_at,
              returnVal: 'NA',
              format: 'MM/DD/YYYY | hh:mm:ss A',
            })}
          </Typography>
          <Typography
            id={`status-${task.id}`}
            gutterBottom
            variant='caption'
            component='div'
            className='text-14 text-gray-variant7 mb-0'>
            Assign To:&nbsp;
            <Typography
              gutterBottom
              variant='caption'
              component='span'
              className='text-white text-14 capitalize'
              title={task.assigned_to ? task.assigned_to.name : 'NA'}>
              {task.assigned_to ? task.assigned_to.name : 'NA'}
            </Typography>
            {isExpired && task.requestable_type !== 'song-request' && (
              <StarIcon
                color='error'
                sx={{
                  fontSize: '15px',
                  position: 'absolute',
                  top: '6px',
                  right: '6px',
                }}
              />
            )}
          </Typography>
        </Grid>

        <Grid container className='flex items-center justify-between mb-2'>
          <Typography
            variant='body2'
            className='text-white text-16'
            sx={{width: 'calc(100% - 10px)'}}>
            {task.task_name}
          </Typography>
          <img src={rightArrow} alt='icon' />
        </Grid>

        <Typography variant='caption' className='block text-14 mb-1'>
          {task.company ? task.company.name : 'NA'}
        </Typography>

        <Grid container className='flex items-center justify-between'>
          <Typography
            variant='caption'
            gutterBottom
            className='text-gray-variant6 text-14'>
            {task.created_by ? task.created_by?.name : 'NA'}
          </Typography>
          <Box>
            <Typography
              id={`status-${task.id}`}
              gutterBottom
              variant='caption'
              component='div'
              className='text-14 text-gray-variant7 mb-0'>
              {/* messages start dates eg: event, ondemand */}
              Created At:&nbsp;
              <Typography
                gutterBottom
                variant='caption'
                component='span'
                className='text-white text-14 capitalize'>
                {dayJsNullHandler({t: task.created_at, returnVal: 'NA'})}
              </Typography>
            </Typography>
            <Typography
              id={`status-${task.id}`}
              gutterBottom
              variant='caption'
              component='div'
              className='text-14 text-gray-variant7 mb-0'>
              {/* messages start dates eg: event, ondemand */}
              Start Date:&nbsp;
              <Typography
                gutterBottom
                variant='caption'
                component='span'
                className='text-white text-14 capitalize'>
                {dayJsNullHandler({
                  t: task.start_date,
                  returnVal: task.start_date ?? 'NA',
                })}
              </Typography>
            </Typography>
          </Box>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TaskListItemCard;
